const PART_LENGTH = 3;
const NOT_ALPHANUMERIC = /[^a-z0-9]/giu;

const partOf = (slug: string | null): string =>
  (slug ?? '').normalize('NFD').replace(NOT_ALPHANUMERIC, '').slice(0, PART_LENGTH).toUpperCase();

export const referencePrefixOf = (subsidiarySlug: string | null, categorySlug: string | null): string =>
  [partOf(subsidiarySlug), partOf(categorySlug)].filter((part) => part !== '').join('-');
